<template>
    <div class="all-height">
        <el-main class="all-height" v-if="flag">
            <div class="operation-bar">
                <div style="background: #d6e3f3; padding: 5px">
                    <el-button @click="closeHandle" size="mini">返 回</el-button>
                    <el-button  :disabled="isLock || subLock" @click="saveInfo" class="submit-form" size="mini" >保 存</el-button>
                    <el-button  :disabled="isLock || subLock" @click="submitInfo" class="submit-form" size="mini" >审 核</el-button>
                </div>
            </div>

            <div class="table-box">
                <el-row style="height: calc(25%)">
                    <el-form :model="offerInfo" :rules="offerRules"  ref="offerForm" label-width="100px">
                        <el-col :span="8">
                            <el-form-item label="需方公司:">
                                <el-input v-model="offerInfo.ownerCompany" size="mini" disabled="disabled"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="询价单号:" >
                                <el-input  v-model="offerInfo.inquiryCode" size="mini" disabled="disabled"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="报价单号:" >
                                <el-input  v-model="offerInfo.offerCode" size="mini" disabled="disabled"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="单据日期:" prop="offerDate">
                                <el-date-picker
                                    style="width: 100%"
                                    size="mini"
                                    v-model="offerInfo.offerDate"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="报价方:" >
                                <el-input  v-model="offerInfo.vendor" size="mini" disabled="disabled"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="报价日期:" prop="quoterDate">
                                <el-date-picker
                                    style="width: 100%"
                                    size="mini"
                                    v-model="offerInfo.quoterDate"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="是否月结:" prop="payMethod">
                                <el-select style="width: 100%" size="mini" v-model="offerInfo.monthPay" placeholder="请选择状态" >
                                    <el-option
                                        v-for="item in monthPayOpt"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="付款描述:" prop="payMethod">
                                <el-input  v-model="offerInfo.payMethod" size="mini"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="有效期:" prop="validDuration">
                                <el-input  v-model="offerInfo.validDuration" size="mini"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="备注:" >
                                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 2}" v-model="offerInfo.remark" size="mini"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form>
                </el-row>
                <el-row style="height: 66%" :gutter="5">
                    <el-col :span="18" class="all-height">
                        <div style="text-align: left; margin-bottom: 1px; padding: 10px; background-color: #1b8fe6;
                        color: #FFFFFF;">
                            <span style="padding-right: 20px;">报价明细</span>
                        </div>
                        <el-table :data="offerInfo.detailList"
                                  border
                                  height="calc(100% + 35px)"
                                  :header-cell-style="{background:'#1b8fe6',color: 'white'}"
                        >
                            <el-table-column fixed width="50px" type="index" label="序号" header-align="center" align="center">
                            </el-table-column>
                            <el-table-column width="150px" prop="mtrlName" label="物料描述" header-align="center" align="center" :show-overflow-tooltip="true">
                            </el-table-column>
<!--                            <el-table-column width="120px"  prop="mtrlSpecs" label="规格型号" header-align="center" align="center" :show-overflow-tooltip="true">-->
<!--                            </el-table-column>-->
                            <el-table-column width="150px"  prop="speReq" label="特殊要求" header-align="center" align="center" :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column width="70px"  prop="uom" label="单位" header-align="center" align="center">
                            </el-table-column>
                            <el-table-column width="80px"  prop="qty" label="数量" header-align="center" align="center" >
                            </el-table-column>
                            <el-table-column width="100px" label="单价" header-align="center" align="center">
                                <template slot-scope="scope">
                                    <el-input  size="mini" v-number-input.float v-model="scope.row.price"></el-input >
                                </template>
                            </el-table-column>
                            <el-table-column width="120px" label="初期报价税率" header-align="center" align="center">
                                <template slot-scope="scope">
                                    <el-input  size="mini"  v-number-input.float v-model="scope.row.earlyTaxRate"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column width="120px" label="初期报价税合计" header-align="center" align="center">
                                <template slot-scope="scope">
                                    <el-input disabled size="mini"  :value="amount1(scope.row.qty,scope.row.price)"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column width="120px" label="议价结果单价" header-align="center" align="center">
                                <template slot-scope="scope">
                                    <el-input  size="mini"  v-number-input.float v-model="scope.row.barPrice"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column width="120px" label="议价结果税率" header-align="center" align="center">
                                <template slot-scope="scope">
                                    <el-input  size="mini"  v-number-input.float v-model="scope.row.barTaxRate"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column width="120px" label="议价结果税合计" header-align="center" align="center">
                                <template slot-scope="scope">
                                    <el-input disabled size="mini"  :value="amount2(scope.row.qty, scope.row.barPrice)"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column width="120px" label="交货期" header-align="center" align="center">
                                <template slot-scope="scope">
                                    <el-input  size="mini" v-model="scope.row.deliveryDuration"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column  width="300px"  label="备注" header-align="center" align="center" :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <el-input  size="mini" v-model="scope.row.remark"></el-input>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                    <el-col :span="6" class="all-height">
                        <div style="text-align: left; margin-bottom: 1px; padding: 7px; background-color: #25a5ee;
                        color: #FFFFFF;">
                            <span style="padding-right: 20px;">附件</span>
                            <el-upload
                                style="display: inline; margin-right: 10px"
                                class="avatar-uploader"
                                action=""
                                :file-list="fileList"
                                :show-file-list="false"
                                :http-request="uploadFile">
                                <el-button :disabled="isLock || subLock" slot="trigger" size="mini" >上传</el-button>
                            </el-upload>
                            <el-button :disabled="isLock || subLock" @click = "delAttachFile"  size="mini" >删除</el-button>
                            <el-button @click = "downLoad" size="mini">下载</el-button>
                        </div>
                        <el-table :data="offerInfo.attachList"
                                  height="calc(100% + 35px)"
                                  ref="attachTb"
                                  @row-click = "rowClick"
                                  @select-all = "selectAll"
                                  @selection-change="handleSelectionChange"
                                  :row-class-name="tableRowClassName"
                                  :header-cell-style="{background:'#25a5ee',color: 'white'}"
                        >
                            <el-table-column
                                fixed
                                type="selection"
                                header-align="center"
                                align="center"
                                width="50">
                            </el-table-column>
                            <el-table-column width="90px" prop="attachName" label="附件名称" header-align="center" align="center" :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column width="110px" label="上传时间" header-align="center" align="center" :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <span style="margin-left: 10px">{{ dateFormat(scope.row.createTime) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column width="80px"  prop="attachSize" label="附件大小" header-align="center" align="center" :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column   prop="uploadUser" label="上传人" header-align="center" align="center">
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
            </div>
        </el-main>
    </div>

</template>

<script>
import {mapState} from 'vuex';
import dayjs from "dayjs";
export default {
    name: 'bill-offer-detail',
    props: ['offerInfo', 'isLock'],
    data() {
        return {
            subLock: false,
            flag: true,
            monthPayOpt: [
                {value: 1, label: '月结'},
                {value: 0, label: '非月结'}
            ],
            statusOpts: [
                {value: '', label: '全部'},
                {value: 0, label: '草稿'},
                {value: 1, label: '保存'}
            ],
            mtrlCateOpts: [
                {value: '电气', label: '电气'},
                {value: '机械', label: '机械'},
                {value: '外协', label: '外协'},
                {value: '后勤', label: '后勤'},
                {value: '钢材', label: '钢材'},
                {value: '电缆线', label: '电缆线'},
                {value: '华原', label: '华原'},
                {value: '蒲瑞', label: '蒲瑞'},
                {value: '矿机', label: '矿机'},
            ],
            fileList: [],
            preDeleteAttachIds: [],
            selectionRows: [],
            offerRules: {
                offerDate: [
                    {required: true, message: '请填写单据日期'}
                ],
                quoterDate: [
                    {required: true, message: '请填写报价日期'}
                ],
                payMethod: [
                    {required: true, message: '请填写付款方式'}
                ],
                validDuration: [
                    {required: true, message: '请填写有效期'}
                ]
            },
            detailRules: {
                price: [
                    {required: true, message: '请输入单价'}
                ]
            },
            loading: false
        };
    },
    computed: {
        ...mapState('bill/billOffer', ['offerDetailInfoList', 'offerAttachInfoList']),
        amount1() {
            return function(x, y){
                return x*y;
            }
        },
        amount2() {
            return function(x, y){
                return x*y;
            }
        }
    },
    methods: {
        closeHandle() {
            this.$emit('closeDetail')
        },
        selectAll() {
            // 禁用全选功能
            this.$refs.attachTb.clearSelection();
        },
        dateFormat(val) {
            if (val) {
                return dayjs(val).format('YYYY-MM-DD');
            } else {
                return '';
            }
        },
        uploadFile(params) {
            this.fileList.push(params.file);
            let vo = {}
            vo.fkBillOfferId = this.offerInfo.id;
            vo.file = params.file;
            this.$store.dispatch('bill/billOffer/uploadFile', vo).then((ret)=>{
                if(ret.code === '200'){
                    this.$store.commit('bill/billOffer/PUSH_OFFER_ATTACH_INFO_LIST', ret.data)
                    this.$message.success('上传成功');
                }else{
                    this.$message.error(ret.data?ret.data : ret.message);
                }
            })
        },

        downLoad() {
            this.$store.dispatch('bill/billOffer/downLoad', {ids: this.selectionRows.join(",")})
        },

        rowClick(row) {
            this.$refs.attachTb.clearSelection();
            this.$refs.attachTb.toggleRowSelection(row);
        },
        tableRowClassName(row, index) {
            // row.row.index = row.rowIndex;
        },
        handleSelectionChange(rows) {
            this.selectionRows = [];
            rows.forEach(item =>{
                this.selectionRows.push(item.id);
            })
        },
        delAttachFile: function () {
            this.$store.dispatch('bill/billOffer/delAttachFile',{ids: this.selectionRows.join(",")}).then((ret)=>{
                if(ret.code === '200'){
                    let detailList = this.$store.state.bill.billOffer.offerInfo.attachList.filter((item, index)=>{
                        let arrList = this.selectionRows;
                        return !arrList.includes(item.id);
                    })
                    this.$store.commit('bill/billOffer/RESET_OFFER_ATTACH_INFO_LIST', detailList)
                    this.$message.success('删除成功');
                }else{
                    this.$message.error('删除失败');
                }
            })

        },

        uploadSectionFile(params) {
            this.fileList.push(params.file);
        },

        saveInfo() {
            this.$refs.offerForm.validate((valid) => {
                this.loading = true;
                if(!valid) {
                    this.loading = false;
                    return;
                }
                this.$store.dispatch('bill/billOffer/saveBillOfferInfo', this.offerInfo).then((ret)=>{
                    if(ret.code === '200'){
                        this.$message.success('保存成功');
                        this.loading = false;
                    }else{
                        this.$message.error('保存失败');
                        this.loading = false;
                    }
                })
            })
        },

        submitInfo() {
            this.$refs.offerForm.validate((valid) => {
                this.loading = true;
                if (!valid) {
                    this.loading = false;
                    return;
                }
                this.$store.dispatch('bill/billOffer/toRemote', this.offerInfo).then((ret)=>{
                    if(ret.code === '200'){
                        this.$message.success('提交成功');
                        this.loading = false;
                        this.subLock = true;
                    }else{
                        this.$message.error('提交失败');
                        this.loading = false;
                    }
                })
            })
        }
    }
}

</script>

<style scoped>
.table-box{
    /*position: relative;*/
    /*margin-top: 5px;*/
    background-color: white;
    height: calc(100% - 45px);
    width: 100%;
}
.table-page {
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 10px;
}
.el-table .el-button{
    padding: 0;
}
.cell i {
    font-size: 25px;
    cursor: pointer;
}
.cell i:hover {
    color: #5ED1FD;
}
.textArea-box {
    max-height: 300px;
    overflow-y: scroll;
}
.el-form .el-col{
    height: 47px;
}
/deep/ .el-form-item__error{
    padding-top: 0px;
}
/deep/ .el-textarea__inner{
    margin-top: 8px;
}
</style>